import {
  DocumentEntityTypesEnum,
  DocumentTypesEnum,
  LookupService,
  LookupTypesEnum,
  ServiceRequestEntityTypesEnum,
} from "@propertelligent/client-api";
import { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import SimpleSpinner from "../../../components/loader";
import { Col, Form, Row } from "react-bootstrap";
import MultipleFileUploader from "../../../newComponents/CustomUploader/MultipleFileUploader";
import {
  JPEG_PNG_EXTENSIONS,
  JPEG_PNG_MIME_TYPES,
} from "../../../newComponents/CustomUploader/imageUploadConstants";
import { GetImages } from "../../../utils/GetImages";
import AddButtonWithArrow from "../../../components/firstTimeUserExperience/commonCom/AddButtonWithArrow";
import apiHelper from "../../../utils/apiHelper";
import CustomInputs from "../../../components/common/Inputs";
import AddTraspButton from "../../../components/firstTimeUserExperience/commonCom/AddTraspButton";
import { sortOptionsAlphabeticallyOtherLast } from "../../../utils/helper";
import { useUnitData } from "../../hooks/useUnitData";

interface AddServiceRequestTenantValues {
  documents_serviceRequestDocuments?: File[];
}

const AddServiceRequestTenant = ({
  ServiceTypes,
  isLoading,
  onClose,
  onConfirm,
}) => {
  const [ServiceSubTypes, setServiceSubTypes] = useState([]);
  const methods = useForm<AddServiceRequestTenantValues>({
    defaultValues: { documents_serviceRequestDocuments: [] },
  });

  const tenantInfoString = sessionStorage.getItem("tenantInfo");
  const tenantInfo = JSON.parse(tenantInfoString);
  const unitId = tenantInfo && tenantInfo.unitId;
  const { unitData, loading: unitLoading } = useUnitData(unitId);
  const unitDisplayValue = unitLoading
    ? "Loading..."
    : `${unitData?.unitNumber ?? ""}${unitData?.unitNumber && unitData?.streetAddress ? " - " : ""}${unitData?.streetAddress ?? ""}`;

  const [values, setValues] = useState({
    entityTypeId: ServiceRequestEntityTypesEnum.Unit,
    serviceType: null,
    entityId: unitId,
    serviceSubType: null,
    description: null,
    requestDate: new Date(),
  });

  const [validated, setValidated] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    if (methods.formState.errors.documents_serviceRequestDocuments) {
      e.stopPropagation();
      return;
    }

    const selectedFiles = methods.getValues("documents_serviceRequestDocuments") || [];
    const docsArr = selectedFiles.map((selectedFile) => ({
      EntityTypeId: DocumentEntityTypesEnum.ServiceRequest,
      EntityId: null,
      DocumentTypeId: DocumentTypesEnum.BeforeImage,
      IsMain: false,
      FileName: selectedFile?.name,
      Document: new Blob([selectedFile]),
      _rawFile: selectedFile,
    }));

    onConfirm({ values, docsArr });
  };

  const handleChangeType = (value) => {
    apiHelper(
      LookupService.getApiLookup1,
      { showNotification: false },
      LookupTypesEnum.ServiceSubTypes,
      value
    )
      .then((response) => setServiceSubTypes(response?.data?.success))
      .catch((err) => { });
  };

  useEffect(() => {
    return () => {
      setServiceSubTypes([]);
      methods.reset({ documents_serviceRequestDocuments: [] });
      setValues({
        entityTypeId: ServiceRequestEntityTypesEnum.Unit,
        serviceType: null,
        entityId: unitId,
        serviceSubType: null,
        description: null,
        requestDate: new Date(),
      });
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <SimpleSpinner />
      ) : (
        <div className="paymentContainer">
          <Form
            noValidate
            validated={validated}
            onSubmit={(e) => handleFormSubmit(e)}
          >
            <div className="paymentInputsContainer">
              <Row className="paymentinputrow">
                <Col>
                  <Form.Group controlId="exampleForm.ControlUnit">
                    <CustomInputs
                      name="unit"
                      labelText="Unit"
                      isFormControl
                      disabled
                      value={unitDisplayValue}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="paymentinputrow">
                <Col>
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label className="sub_text  grey_subtext1">
                      Service Type *
                    </Form.Label>
                    <Form.Select
                      className="sub_text  grey_subtext1"
                      aria-label="Default Service Typ"
                      required
                      value={values?.serviceType}
                      onChange={(e) => {
                        setValues({
                          ...values,
                          serviceType: Number(e.target.value),
                        });
                        handleChangeType(Number(e.target.value));
                      }}
                    >
                      <option value="">Service Type</option>
                      {sortOptionsAlphabeticallyOtherLast(ServiceTypes ?? [], (item: any) => item?.name ?? "").map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback
                      type="invalid"
                      className="invalid-feedback"
                    >
                      Please select a Service Type
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label className="sub_text  grey_subtext1">
                      Service Sub Type *
                    </Form.Label>
                    <Form.Select
                      className="sub_text  grey_subtext1"
                      aria-label="Default select Service Sub Type"
                      required
                      value={values?.serviceSubType}
                      onChange={(e) =>
                        setValues({
                          ...values,
                          serviceSubType: Number(e.target.value),
                        })
                      }
                    >
                      <option value="">Service Sub Type</option>
                      {sortOptionsAlphabeticallyOtherLast(ServiceSubTypes ?? [], (item: any) => item?.name ?? "").map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback
                      type="invalid"
                      className="invalid-feedback"
                    >
                      Please select a Service Sub Type
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="paymentinputrow">
                <Form.Group controlId="exampleForm.ControlTextarea1">
                  <CustomInputs
                    name="description"
                    labelText="Description"
                    placeholder="Enter Description"
                    required
                    isFormControl
                    value={values?.description}
                    onChange={(e) =>
                      setValues({ ...values, description: e?.target?.value })
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className="invalid-feedback"
                  >
                    Entere Description.
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="paymentinputrow">
                <Col>
                  <div
                    className="documentUploadContainer"
                    style={{ marginBottom: "8px", width: "100%" }}
                  >
                    <FormProvider {...methods}>
                      <MultipleFileUploader
                        name="documents_serviceRequestDocuments"
                        uploaderId="addServiceRequestTenantDocuments"
                        label="Upload Documents"
                        required={false}
                        disabled={isLoading}
                        allowedFormats={[...JPEG_PNG_MIME_TYPES]}
                        allowedExtensions={[...JPEG_PNG_EXTENSIONS]}
                        maxSizeMB={1}
                        maxFiles={5}
                        uploadertext="Upload Files"
                        uploadertypeslabel="Max. size 1MB. JPEG, PNG (Max 5 files)"
                        convertImagesToPng={false}
                      />
                    </FormProvider>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="tenantFormFooter">
              <div className="footerRightButtons">
                <AddTraspButton
                  type="button"
                  bname="Cancel"
                  onClick={onClose}
                  width="fit-content"
                />
                <AddButtonWithArrow
                  buttonname="Add Request"
                  onClick={undefined}
                  disabled={undefined}
                  iconDirection="left"
                  Icon={GetImages.WhiteForwardArrow}
                />
              </div>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};

export default AddServiceRequestTenant;
